import React from 'react';
import { FormattedMessage } from 'react-intl';
import { CenterJustifiedContainer } from '../center-justified-container';
import { MobileVerticallyPaddedContainer } from './mobile-vertically-padded-container';

export type EnterpriseUnmetMinProps = {
  minRequiredUnits: number;
};

const EnterpriseUnmetMin = ({ minRequiredUnits }: EnterpriseUnmetMinProps) => (
  <CenterJustifiedContainer>
    <MobileVerticallyPaddedContainer>
      <FormattedMessage
        tagName={'p'}
        id="enterpriseUnmetMin"
        defaultMessage="Enterprise plan pricing is available when you enter {minRequiredUnits} or more users above"
        values={{ minRequiredUnits }}
      />
    </MobileVerticallyPaddedContainer>
  </CenterJustifiedContainer>
);

export { EnterpriseUnmetMin };
